import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import EmployeeTemplate from '../../components/employeemng/EmployeeTemplate';



import { unloadEmployee, viewEmployee } from '../../modules/empModule/employee';
import EmployeeFormContainer from './EmployeeFormContainer';
import PersonalTabsContainer from './personal/PersonalTabsContainer';
import NpTabsContainer from './np/NpTabsContainer';
import ResultTabsContainer from './result/ResultTabsContainer';
import ResumeTabsContainer from './resume/ResumeTabsContainer';


const EmployeeEditContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { employee, error, loading } = useSelector(
    ({ empModule, loading }) => ({
      employee: empModule.employee.employee,
      error: empModule.employee.error,
      loading: loading['employee/VIEW_EMPLOYEE'],
    }),
  );

  useEffect(() => {
    dispatch(viewEmployee(id));

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadEmployee());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (employee) {
      let title = {
        name: "[" + employee.usrNo + "] " + employee.usrNm + ' ' + employee.gradeNm,
        no: employee.usrNo,
      };
      setTitleData(title);
    }
  }, [employee]);

  const handleGoBack = () => {
    navigate(`/employeemng/${id}`);
  };

  //   const handleDelete = () => {
  //     console.log(product);
  //   };

  return (
    <EmployeeTemplate employee={employee} loading={loading} error={error}>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="인사 관리/사원 관리/수정"
        menuLink="/employeemng"
        icon="user"
        titleData={titleData}
      />

      <DetailTemplate title="기본사항">
        <EmployeeFormContainer type="edit" />
      </DetailTemplate>
      <DetailTemplate title="이력사항">
        <ResumeTabsContainer edit />
      </DetailTemplate>
      {/* <DetailTemplate title="성과관리">
        <ResultTabsContainer edit />
      </DetailTemplate> */}
      <DetailTemplate title="개인상세 정보">
        <PersonalTabsContainer edit />
      </DetailTemplate>
      {/* <DetailTemplate title="국책과제 참여 현황">
        <NpTabsContainer edit />
      </DetailTemplate> */}
    </EmployeeTemplate>
  );
};

export default EmployeeEditContainer;
